<template>
  <div class="input-button">
    <div class="input">
      <GSInput
        :radius="9"
        :placeholder="placeholder"
        @changed="inputChanged"
      ></GSInput>
    </div>
    <div class="button">
      <GSButton
        color="blue"
        :text="text"
        :radius="6"
        :disabled="buttonDisabled"
        @clicked="clicked"
      ></GSButton>
    </div>
  </div>
</template>

<script>
import GSInput from './GSInput'
import GSButton from './GSButton'

import { EVENT } from '@/constants/event'

export default {
  name: 'GSInputButton',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clicked () {
      this.$emit(EVENT.CLICKED)
    },
    inputChanged (newVal) {
      this.$emit(EVENT.CHANGED, newVal)
    }
  },
  components: {
    GSInput,
    GSButton
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.input-button {
  display: flex;

  .input {
    flex: 55%;
    min-width: 0;
    border-radius: $radius-size 0 0 $radius-size;
  }

  .button {
    flex: 45%;
    flex-basis: auto;
    flex-grow: 1;
    min-width: $base-size * 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSInputButton.vue